module.exports = __webpack_public_path__ + "static/media/messaging_inbox.066b0a18.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/messaging_inbox.md
// module id = 1103
// module chunks = 0